export const ORB_DOMAIN = 'app/modules/ORB/ORB_DOMAIN';
export const FETCH_ORB_STOCK = 'app/modules/ORB/FETCH_ORB_STOCK';
export const VALIDATE_RDW = 'app/modules/ORB/VALIDATE_RDW';
export const CONFIRM_CAR = 'app/modules/ORB/CONFIRM_CAR';
export const GET_INCOMING_CARS = 'app/modules/ORB/GET_INCOMING_CARS';
export const ORB_TRANSFER_OUT = 'app/modules/ORB/ORB_TRANSFER_OUT';
export const RETRIEVE_VEHICLE_TVI = 'app/modules/ORB/RETRIEVE_VEHICLE_TVI';
export const REQUEST_VEHICLE_TVI = 'app/modules/ORB/REQUEST_VEHICLE_TVI';
